import React, { Component } from 'react'
import MenuCatalog from './MenuCalalog'
import MenuNoticias from './MenuNoticias'
import { useLocation } from 'react-router-dom'
import MenuExtratos from './MenuExtratos';
import MenuHome from './MenuHome';
import MenuFaq from './MenuFaq'
import MenuRelatorio from './MenuRelatorio';
import MenuExtratoComparativoTransferencia from './MenuExtratoComparativoTransferencia';
import MenuExtratosComparativoIndice from './MenuExtratoComparativoIndice';
import MenuParceiros from './MenuParceiros';

export default function LeftSidebar() {
  const location = useLocation();
  return (
    <>
      {/* <!-- Left Sidebar --> */}
      <aside id="leftsidebar" className="sidebar" style={{ zIndex: 999, borderBottomRightRadius: '10px', }}>
        {/* <div className="user-info">
          <div className="image">
            <img src="assets/images/xs/logo.svg" width="48" height="48" alt="User" />
          </div>
          <div className="info-container">
            <br />
            <div className="name" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" role="button"><span style={{ fontSize: '14px' }}>  <i className='zmdi zmdi-calendar'></i>  PERIODOS DISPONÍVEIS </span></div>
            <div className="email"> <span style={{ fontSize: '11px' }}>  </span></div>
          </div>
        </div> */}
        {/* <MenuCatalog /> */}
        {/* {JSON.stringify(location)} */}
        {location.pathname == '/transferenciasglobais' ? <MenuHome /> : null}
        {location.pathname == '/' ? <MenuExtratos /> : null}
        {location.pathname == '/extratos' ? <MenuExtratos /> : null}
        {location.pathname == '/noticias' || location.pathname == '/noticias/periodo' ? <MenuNoticias /> : null}
        {location.pathname == '/faqs' ? <MenuFaq /> : null}
        {location.pathname == '/faqscategoria' ? <MenuFaq /> : null}
        {location.pathname == '/extratos/relatorio' ? <MenuRelatorio /> : null}
        {location.pathname == '/extratos/comparativo/transferencia' ? <MenuExtratoComparativoTransferencia /> : null}
        {location.pathname == '/extratos/comparativo/indice' ? <MenuExtratosComparativoIndice /> : null}
        {location.pathname == '/parceiros' ? <MenuParceiros /> : null}

      </aside>


    </>
  )

}